import React, { useState } from 'react';
import { StatusBadge } from '../components/StatusBadge';
import { Search, Plus } from 'lucide-react';
import { AddGLPostingModal } from '../components/AddGLPostingModal';
export function GLPostingsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [voucherDate, setVoucherDate] = useState('');
  const [postingDate, setPostingDate] = useState('');
  const [purposeFilter, setPurposeFilter] = useState('All');
  const [statusFilter, setStatusFilter] = useState('All');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [postings, setPostings] = useState([{
    id: 'VCH-20260110-001',
    voucherDate: '10 Jan 2026',
    postingDate: '10 Jan 2026',
    purpose: 'Disbursement',
    debitAmount: 'PKR 500,000',
    creditAmount: 'PKR 500,000',
    createdBy: 'System',
    status: 'Posted'
  }, {
    id: 'VCH-20260112-042',
    voucherDate: '12 Jan 2026',
    postingDate: '12 Jan 2026',
    purpose: 'Repayment',
    debitAmount: 'PKR 49,167',
    creditAmount: 'PKR 49,167',
    createdBy: 'System',
    status: 'Posted'
  }, {
    id: 'VCH-20260115-018',
    voucherDate: '15 Jan 2026',
    postingDate: '15 Jan 2026',
    purpose: 'Fee Collection',
    debitAmount: 'PKR 5,000',
    creditAmount: 'PKR 5,000',
    createdBy: 'Admin User',
    status: 'Posted'
  }, {
    id: 'VCH-20260201-005',
    voucherDate: '01 Feb 2026',
    postingDate: '01 Feb 2026',
    purpose: 'Adjustment',
    debitAmount: 'PKR 12,500',
    creditAmount: 'PKR 12,500',
    createdBy: 'Finance Mgr',
    status: 'Pending'
  }, {
    id: 'VCH-20260210-088',
    voucherDate: '10 Feb 2026',
    postingDate: '10 Feb 2026',
    purpose: 'Penalty',
    debitAmount: 'PKR 500',
    creditAmount: 'PKR 500',
    createdBy: 'System',
    status: 'Posted'
  }, {
    id: 'VCH-20260215-022',
    voucherDate: '15 Feb 2026',
    postingDate: '15 Feb 2026',
    purpose: 'Repayment',
    debitAmount: 'PKR 48,867',
    creditAmount: 'PKR 48,867',
    createdBy: 'System',
    status: 'Posted'
  }, {
    id: 'VCH-20260301-011',
    voucherDate: '01 Mar 2026',
    postingDate: '01 Mar 2026',
    purpose: 'Adjustment',
    debitAmount: 'PKR 2,000',
    creditAmount: 'PKR 2,000',
    createdBy: 'Finance Mgr',
    status: 'Reversed'
  }, {
    id: 'VCH-20260310-003',
    voucherDate: '10 Mar 2026',
    postingDate: '10 Mar 2026',
    purpose: 'Disbursement',
    debitAmount: 'PKR 1,000,000',
    creditAmount: 'PKR 1,000,000',
    createdBy: 'Admin User',
    status: 'Pending'
  }]);
  const handleSavePosting = (data: any) => {
    const newPosting = {
      id: data.voucherNumber,
      voucherDate: new Date(data.voucherDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }),
      postingDate: new Date(data.postingDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }),
      purpose: data.purpose,
      debitAmount: `PKR ${data.totalDebit.toLocaleString()}`,
      creditAmount: `PKR ${data.totalCredit.toLocaleString()}`,
      createdBy: 'Current User',
      status: 'Pending'
    };
    setPostings([newPosting, ...postings]);
    setIsModalOpen(false);
  };
  const filteredData = postings.filter(item => {
    const matchesSearch = item.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesPurpose = purposeFilter === 'All' || item.purpose === purposeFilter;
    const matchesStatus = statusFilter === 'All' || item.status === statusFilter;
    // Basic date filtering logic (exact match on ISO string if selected)
    let matchesVoucherDate = true;
    if (voucherDate) {
      const vDate = new Date(item.voucherDate).toISOString().split('T')[0];
      matchesVoucherDate = vDate === voucherDate;
    }
    let matchesPostingDate = true;
    if (postingDate) {
      const pDate = new Date(item.postingDate).toISOString().split('T')[0];
      matchesPostingDate = pDate === postingDate;
    }
    return matchesSearch && matchesPurpose && matchesStatus && matchesVoucherDate && matchesPostingDate;
  });
  return <div className="space-y-6" data-id="element-708">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-709">
        <div data-id="element-710">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-711">GL Postings</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-712">
            View and manage General Ledger transactions.
          </p>
        </div>
        <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:w-auto" data-id="element-713">
          <Plus className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" data-id="element-714" />
          Add GL Posting
        </button>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex flex-col lg:flex-row gap-4 items-end" data-id="element-715">
        <div className="w-full lg:flex-1" data-id="element-716">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-717">
            Voucher #
          </label>
          <div className="relative rounded-md shadow-sm" data-id="element-718">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-719">
              <Search className="h-4 w-4 text-gray-400" aria-hidden="true" data-id="element-720" />
            </div>
            <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" placeholder="Search voucher..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-721" />
          </div>
        </div>

        <div className="w-full sm:w-40" data-id="element-722">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-723">
            Voucher Date
          </label>
          <input type="date" value={voucherDate} onChange={e => setVoucherDate(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-724" />
        </div>

        <div className="w-full sm:w-40" data-id="element-725">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-726">
            Posting Date
          </label>
          <input type="date" value={postingDate} onChange={e => setPostingDate(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-727" />
        </div>

        <div className="w-full sm:w-48" data-id="element-728">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-729">
            Purpose
          </label>
          <select value={purposeFilter} onChange={e => setPurposeFilter(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-730">
            <option value="All" data-id="element-731">All</option>
            <option value="Disbursement" data-id="element-732">Disbursement</option>
            <option value="Repayment" data-id="element-733">Repayment</option>
            <option value="Fee Collection" data-id="element-734">Fee Collection</option>
            <option value="Penalty" data-id="element-735">Penalty</option>
            <option value="Adjustment" data-id="element-736">Adjustment</option>
          </select>
        </div>

        <div className="w-full sm:w-40" data-id="element-737">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-738">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-739">
            <option value="All" data-id="element-740">All</option>
            <option value="Posted" data-id="element-741">Posted</option>
            <option value="Pending" data-id="element-742">Pending</option>
            <option value="Reversed" data-id="element-743">Reversed</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-lg overflow-hidden" data-id="element-744">
        <div className="overflow-x-auto" data-id="element-745">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-746">
            <thead className="bg-gray-50" data-id="element-747">
              <tr data-id="element-748">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-749">
                  Voucher #
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-750">
                  Voucher Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-751">
                  Posting Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-752">
                  Purpose
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-753">
                  Debit Amount
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-754">
                  Credit Amount
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-755">
                  Created By
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-756">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white" data-id="element-757">
              {filteredData.map(item => <tr key={item.id} className="hover:bg-gray-50 transition-colors" data-id="element-758">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-759">
                    {item.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-760">
                    {item.voucherDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-761">
                    {item.postingDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-762">
                    {item.purpose}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right" data-id="element-763">
                    {item.debitAmount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right" data-id="element-764">
                    {item.creditAmount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-765">
                    {item.createdBy}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-766">
                    <StatusBadge status={item.status} data-id="element-767" />
                  </td>
                </tr>)}
              {filteredData.length === 0 && <tr data-id="element-768">
                  <td colSpan={8} className="px-6 py-8 text-center text-sm text-gray-500" data-id="element-769">
                    No GL postings found matching your filters.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      <AddGLPostingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSavePosting} data-id="element-770" />
    </div>;
}